import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import { useToasts } from "react-toast-notifications";

import classes from "./notification.module.scss";
import { ReactComponent as NotificationIcon } from "@/assets/images/desktop/notificacionverde.svg";
import { ReactComponent as DeleteIcon } from "@/assets/images/desktop/cerrar.svg";

import Fetching from "@/components/Fetching/Fetching";
import Head from "@/components/Content/Head";
import NotificacionText from "./NotificacionText";

import { notificationSeen, notificationMultipleSeen } from "@/redux/actions/auth.actions";

import { dateToLocale } from "@/services/Utils";

const Notification = () => {
	const dispatch = useDispatch();
	const { addToast } = useToasts();

	const { notifications } = useSelector((state) => state.auth);

	const [isFetching, setIsFetching] = useState(false);

	const handleDelete = (notification_id) => {
		setIsFetching(true);
		dispatch(notificationSeen(notification_id))
			.then((_data) => {
				addToast("Notificación eliminada correctamente.", {
					appearance: "success",
				});
			})
			.finally(() => {
				setIsFetching(false);
			});
	};

	const handleDeleteMultiple = () => {
		setIsFetching(true);
		dispatch(notificationMultipleSeen(notifications))
			.then((_data) => {
				addToast("Notificaciones eliminadas correctamente.", {
					appearance: "success",
				});
			})
			.finally(() => {
				setIsFetching(false);
			});
	};

	if (isFetching) {
		return <Fetching />;
	}

	return (
		<>
			<Head title={"Notificaciones"} />

			<Row className={`no_print ${classes.notificationGlobal}`}>
				<Col md={12} className={classes.removeNotification}>
					<div onClick={() => handleDeleteMultiple()}>Vaciar notificaciones</div>
				</Col>

				<Row className={classes.notificationScroll}>
					{notifications.length !== 0 ? (
						notifications.map((notification, i) => {
							return (
								<Col key={i} md={12} className={classes.notification}>
									<Row className={classes.baseNotification}>
										<Col md={1} className={classes.notificationIcon}>
											<NotificationIcon />
										</Col>
										<Col md={2} xs={3} className={classes.notificationDate}>
											{dateToLocale(notification.date)} <br />
											{notification.time}
										</Col>
										<Col md={8} xs={7} className={classes.notificationText}>
											<NotificacionText notification={notification} />
										</Col>
										<Col md={1} xs={1}>
											<DeleteIcon className={classes.icon} onClick={() => handleDelete(notification.id)} />
										</Col>
									</Row>
								</Col>
							);
						})
					) : (
						<Col md={12} className={classes.notification}>
							<Row className={classes.baseNotification}>
								<Col
									md={12}
									style={{
										textAlign: "center",
										fontSize: "20px",
										color: "#5e5e5e",
									}}
								>
									No tienes notificaciones
								</Col>
							</Row>
						</Col>
					)}
				</Row>
			</Row>
		</>
	);
};

export default Notification;
